import { Component } from 'react';
import * as app from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyBfHaiu8HEaliBx4DzjqhmF-ryxhctqI84',
  authDomain: 'my-portfolio-60b5a.firebaseapp.com',
  projectId: 'my-portfolio-60b5a',
  storageBucket: 'my-portfolio-60b5a.appspot.com',
  messagingSenderId: '945872026521',
  appId: '1:945872026521:web:2d7f7a44052f6dd5e2f108',
  measurementId: 'G-WBHS2K6573',
};

export default class Firebase extends Component {
  constructor(props) {
    super(props);
    // alert(process.env.REACT_APP_API_KEY)

    // app.initializeApp(firebaseConfig);
    // app.analytics();

    // this.db = app.database();
    // console.log(this.db.ref('/projects'));
    // this.projects = () => this.db.ref('/projects');
  }
}
const appFB = app.initializeApp(firebaseConfig);
// storage.
export const db = getDatabase(appFB);
// export const storageRef = firebase.storage(app).ref()
export const storageRef = getStorage(appFB);

const analytics = getAnalytics(appFB);

export const initFB = () => {
  app.initializeApp(firebaseConfig);
};

export const logEventPage = (title, param) => {
  try {
    console.log('Called');
    logEvent(analytics, 'page_view', { page_title: title, page_path: param });
  } catch (err) {
    console.log('er : ', err);
  }
};
